import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import GenericAddButton from 'widgets/GenericAddButton/GenericAddButton';

import SearchIcon from '@mui/icons-material/Search';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

const FiltroStripe = ({ handleSubmit, onSubmit, register, errors }) => {
  const [currentDate, setCurrentDate] = useState('');
  useEffect(() => {
    const today = new Date().toISOString();
    const todayMexico = convertToMexicoTime(today);
    setCurrentDate(todayMexico.split(' ')[0]);
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={1} alignItems='center'>
        <Grid size={{ xs: 12, md: 2 }}>
          <TextField
            fullWidth
            label='Desde'
            type='date'
            {...register('from_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.from_date)}
            helperText={errors.from_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 2 }}>
          <TextField
            fullWidth
            label='Hasta'
            type='date'
            {...register('to_date')}
            InputLabelProps={{
              shrink: true,
            }}
            error={Boolean(errors.to_date)}
            helperText={errors.to_date?.message}
            slotProps={{
              htmlInput: {
                max: currentDate,
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 2 }}>
          <TextField
            fullWidth
            label='PI Stripe'
            type='text'
            {...register('payment_intent')}
            error={Boolean(errors.payment_intent)}
            helperText={errors.payment_intent?.message}
            onWheel={(e) => e.target.blur()}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 1 }}>
          <FormControl fullWidth>
            <InputLabel id='demo-simple-select-label'>Status</InputLabel>
            <Select
              fullWidth
              {...register('status_id')}
              error={Boolean(errors.status_id)}
              helperText={errors.status_id?.message}
            >
              <MenuItem value={'succeeded'}>Éxito</MenuItem>
              <MenuItem value={'failed'}>Fallo</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <TextField
            fullWidth
            label='Tarjeta'
            {...register('masked_pan_termination', {
              pattern: {
                value: /^[0-9Xx*]+$/,
                message: 'Solo se permiten números',
              },
              maxLength: {
                value: 4,
                message: 'Máximo 4 caracteres',
              },
              minLength: {
                value: 4,
                message: 'Mínimo 4 caracteres',
              },
            })}
            error={Boolean(errors.masked_pan_termination)}
            helperText={errors.masked_pan_termination?.message}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 1 }}>
          <TextField
            fullWidth
            label='Monto'
            type='number'
            {...register('amount')}
            error={Boolean(errors.amount)}
            helperText={errors.amount?.message}
            onWheel={(e) => e.target.blur()}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 2 }}>
          <GenericAddButton
            buttonText='Buscar'
            backgroundColor='#4C2484'
            size='medium'
            isSubmit
            icon={<SearchIcon />}
          />
        </Grid>
      </Grid>
    </form>
  );
};

export default FiltroStripe;
